<template>
  <div id="app">
    <Navigation :account-id="accountId"/>
  </div>
</template>

<style lang="scss">
</style>


<script>

import Navigation from './components/nav/Navigation'

export default {
  props: {
    accountId: {
      type: String
    }
  },
  components: {
    Navigation
  }
}

</script>
